import React from "react";
import PropTypes from "prop-types";

import { ReactComponent as Phone } from "../../../assets/icons/phone.svg";
import { ReactComponent as Email } from "../../../assets/icons/email.svg";

const PharmacyCard = ({ item }) => {
  return (
    <div
      className="w-full space-y-2.5"
      data-testid={`report-event-pharmacy-card-${item?.id ?? item?.full_name}`}
    >
      <div className="mt-5 text-base font-bold leading-snug text-[#00567a]">
        {item?.full_name}
      </div>
      <p className="text-base leading-snug text-[#374151]">
        For reporting adverse events:
      </p>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Phone className="h-4 w-4 shrink-0 text-[#00567a]" aria-hidden />
        <span className="text-base font-semibold text-[#374151]">
          Tel:{" "}
          <a
            className="font-normal text-[#646464] no-underline underline-offset-2 transition-colors hover:text-[#374151] hover:underline"
            href={`tel:${item?.phone_number}`}
            data-testid="report-event-pharmacy-phone-link"
          >
            {item?.phone_number}
          </a>
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Email className="h-4 w-4 shrink-0 text-[#00567a]" aria-hidden />
        <span className="text-base font-semibold text-[#374151]">
          Email:{" "}
          <a
            className="font-normal text-[#646464] no-underline underline-offset-2 transition-colors hover:text-[#374151] hover:underline"
            href={`mailto:${item?.email}`}
            data-testid="report-event-pharmacy-email-link"
          >
            {item?.email}
          </a>
        </span>
      </div>
    </div>
  );
};

PharmacyCard.propTypes = {
  item: PropTypes.object,
};
export default PharmacyCard;
